import React from 'react';
import { Variable } from 'src/api/types';

/**
 * Provides the current variable list to the chip node-views and the suggestion popup, both of
 * which render via React portals into the editor tree (so they can read this context).
 * Updating `variables` here re-renders chips with fresh values without re-parsing the doc.
 */
export const VariablesContext = React.createContext<{
  variables: Variable[];
  workspaceVariableNames: Set<string>;
}>({
  variables: [],
  workspaceVariableNames: new Set(),
});
